// ─────────────────────────────────────────────────────────────────────────────
// Body-shape option metadata — used by the Find My Size wizard's body steps.
//
// Design decision (2026-08-17): Sayz's editorial/typography-forward DNA does
// not fit stick-figure silhouettes. Instead we lean on:
//   - Lucide's PersonStanding as a single subtle reference icon per card
//   - Big typography for the variant label ("Dar" / "Normal" / "Geniş")
//   - A minimal width-indicator bar that visually reinforces the variant
//
// This module is a plain-data module — presentation lives in WizardPreview.jsx.
// Variant `value`s are STABLE across live/preview so profile.chest, etc. stay
// interchangeable when we port to the live bundle later.
// ─────────────────────────────────────────────────────────────────────────────

export const BODY_SHAPE_OPTIONS = {
    chest: {
        prompt: "Göğüs yapını en iyi hangisi tanımlıyor?",
        options: [
            { value: "narrow", label: "Dar",    hint: "İnce üst gövde",       barWidth: 32 },
            { value: "normal", label: "Normal", hint: "Dengeli, orta hat",    barWidth: 60 },
            { value: "wide",   label: "Geniş",  hint: "Dolgun, atletik üst",  barWidth: 92 },
        ],
    },
    waist: {
        prompt: "Bel/karın yapını en iyi hangisi tanımlıyor?",
        options: [
            { value: "flat",   label: "Düz",      hint: "Bel ve karın tek hat",   barWidth: 32 },
            { value: "normal", label: "Normal",   hint: "Hafif belirgin bel",     barWidth: 60 },
            { value: "round",  label: "Yuvarlak", hint: "Daha dolgun bel bölgesi", barWidth: 92 },
        ],
    },
    hip: {
        prompt: "Kalça yapını en iyi hangisi tanımlıyor?",
        options: [
            { value: "narrow", label: "Dar",    hint: "İnce kalça hattı",       barWidth: 32 },
            { value: "normal", label: "Normal", hint: "Ortalama kalça yapısı",  barWidth: 60 },
            { value: "wide",   label: "Geniş",  hint: "Belirgin, dolgun kalça", barWidth: 92 },
        ],
    },
    shoulder: {
        prompt: "Omuz yapını en iyi hangisi tanımlıyor?",
        options: [
            { value: "narrow", label: "Dar",   hint: "İnce omuz hattı",     barWidth: 32 },
            { value: "normal", label: "Orta",  hint: "Dengeli omuz hattı",  barWidth: 60 },
            { value: "wide",   label: "Geniş", hint: "Geniş ve dik omuz",   barWidth: 92 },
        ],
    },
};
